<app-third-party-loader
    *ngIf="adtractionScriptUrl"
    [consent]="consent"
    [url]="adtractionScriptUrl"
></app-third-party-loader>
